import tw, { styled } from 'twin.macro';

const BranchContainer = styled.div`
  ${tw`lg:w-1/2 xl:w-1/3 z-10`}
`;

export default BranchContainer;
